export const loginConstant = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN: 'LOGIN',
};

export const categoryItemConstant = {
  ITEM_CATEGORY_REQUEST: 'ITEM_CATEGORY_REQUEST',
  ITEM_CATEGORY_SUCCESS: 'ITEM_CATEGORY_SUCCESS',
  ITEM_CATEGORY_FAILURE: 'ITEM_CATEGORY_FAILURE',
};
export const employeeConstant = {
  EMPLOYEE_REQUEST: 'EMPLOYEE_REQUEST',
  EMPLOYEE_SUCCESS: 'EMPLOYEE_SUCCESS',
  EMPLOYEE_FAILURE: 'EMPLOYEE_FAILURE',
};
export const customerConstant = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  CUSTOMER_SUCCESS: 'CUSTOMER_SUCCESS',
  CUSTOMER_FAILURE: 'CUSTOMER_FAILURE',
};
